<template>
  <header class="wrapper" v-if="isShowHeader">
    <div class="back_wrapper" v-if="isBack">
      <a @click="goBack">
        <img src="@/assets/images/btn-arrow-left.svg" alt="btn-left-arrow" />
      </a>
    </div>
    <div class="wrapper__logo" v-if="isHeaderLogo">
      <router-link :to="{path: '/'}">
        <img
          style="cursor: pointer;"
          src="../../assets/images/logo-logo-fundanow-bb.svg"
          alt="funda-now-logo"
        />
      </router-link>
    </div>
    <div class="wrapper__head" v-if="isHeaderTitle">
      <div class="title">
        <h3>{{$store.state.ui.header.title}}</h3>
      </div>
    </div>
    <button
      v-ripple
      class="wrapper__info--rectangle"
      @click="$router.push({name: 'my'})"
      v-if="isMyInfoBtn"
    >나의 정보</button>
  </header>
</template>
<script>
import HeaderEventBus from '@/eventbus/HeaderEventBus'

import { mapGetters } from 'vuex'

export default {
  methods: {
    goBack() {
      if (this.$store.state.ui.header.isGobackEvent) {
        HeaderEventBus.gobackButtonClick()
      } else if (this.isBackToDashboard) {
        this.$router.push({ name: 'dashboard' })
      } else if (this.isBackToDocuments) {
        this.$router.push({ name: 'documents' })
      } else if (this.isBackToMy) {
        this.$router.push({ name: 'my' })
      } else if (this.isBackToTalks) {
        let params = {}
        if (this.$route && this.$route.params && this.$route.params.uuid) {
          params.uuid = this.$route.params.uuid
        }
        this.$router.push({ name: 'talks', params: params })
      } else {
        this.$router.go(-1)
      }
    },
    isIgnoreHeader(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (this.$route.name === arr[i]) {
          return false
        }
      }
      return true
    },
    isVisibleHeader(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (this.$route.name === arr[i]) {
          return true
        }
      }
      return false
    },
  },
  computed: {
    ...mapGetters('status', {
      status: 'getStatus'
    }),
    ...mapGetters('auth', {
      isSignin: 'isSignin'
    }),
    isBack() {
      return this.isVisibleHeader([
        'my',
        'ordersales',
        'cardsales/form',
        'documents',
        'my/repayments',
        'my/loans',
        'my/loansDetail',
        'talks',
        'talks/:uuid',
        'notices/:uuid'
      ])
    },
    isMyInfoBtn() {
      if (this.isSignin === false) {
        return
      }

      let isVisible = this.isVisibleHeader(['dashboard'])
      if (this.status.code && ['not_defined', 'no_cfa_account', 'not_cfa_account', 'no_cardsales', 'not_cardsales', 'no_credit', 'not_credit'].indexOf(this.status.code) >= 0) {
        isVisible = false
      }
      return isVisible
    },
    isHeaderLogo() {
      return this.isVisibleHeader(['dashboard', 'error404', 'landing/overcome-corona'])
    },
    isHeaderTitle() {
      return this.isIgnoreHeader(['signin', 'dashboard', 'todaystore', 'todaystore/event', 'todaystore/landing', 'connect/todaystore'])
    },
    isShowHeader() {
      return this.isIgnoreHeader(['main', 'signin', 'pirate', 'todaystore', 'todaystore/event', 'todaystore/landing', 'connect/todaystore', 'documents/limittransaction', 'landing/invitation/corona', 'landing/invitation/bnk', 'landing/manual', 'marketing', 'loan/contract'])
    },
    isBackToDashboard() {
      return this.isVisibleHeader(['my', 'factoring/confirm', 'loan/confirm', 'talks'])
    },
    isBackToDocuments() {
      return this.isVisibleHeader(['agreements'])
    },
    isBackToMy() {
      return this.isVisibleHeader(['documents', 'my/repayments', 'my/loans'])
    },
    isBackToTalks() {
      return this.isVisibleHeader(['talks/:uuid'])
    },
    isBackToNotice() {
      return this.isVisibleHeader(['notices/:uuid'])
    },
  }
}
</script>
